import { Stack } from "@mui/material";

import PartWaxDetails from "./forms/PartWaxDetails";
import PartAssembly from "./forms/PartAssembly";
import PartDipDetails from "./forms/PartDipDetails";
import PartAutoclave from "./forms/PartAutoclave";
import PartFoundry from "./forms/PartFoundry";
import PartPostFoundry from "./forms/PartPostFoundry";

const DEPARTMENT_FORMS = {
  1: PartWaxDetails,
  12: PartAssembly,
  2: PartDipDetails,
  3: PartAutoclave,
  4: PartFoundry,
  5: PartPostFoundry,
};

const SECTIONS_FOR_DEPARTMENT = {
  1: [1, 12],
  12: [12],
  2: [2],
  3: [3],
  4: [4],
  5: [5],
};

const PartDetailsFields = ({ data = {} }) => {
  const instructions = data?.instructions || [];
  const workOrder = data?.workOrder || {};
  const departmentId = data?.departmentId;

  const byDept = new Map(instructions.map((i) => [i.departmentId, i]));
  const visible = SECTIONS_FOR_DEPARTMENT[departmentId] || [];

  return (
    <Stack
      gap="25px"
      width="100%"
      sx={{
        "& .HubHighlitedDetailField": {
          width: "100%",
          height: "100%",
          "& .HubHighlitedDetailField-caption": { height: "100%" },
        },
      }}
    >
      {visible.map((dept) => {
        const section = byDept.get(dept);
        const Form = DEPARTMENT_FORMS[dept];
        if (!section || !Form) return null;
        return <Form key={dept} section={section} workOrder={workOrder} />;
      })}
    </Stack>
  );
};

export default PartDetailsFields;
